import { Component } from '@angular/core';
import { IonicPage, NavParams } from 'ionic-angular';
import {
  GoogleMaps,
  GoogleMap,
  GoogleMapsEvent,
  Marker,
  GoogleMapsAnimation,
  MyLocation,
  Environment
} from '@ionic-native/google-maps';
import { NavController, ModalController, AlertController, Platform } from 'ionic-angular';
import * as moment from 'moment';

import { VariablesProvider } from '../../providers/variables/variables';
import { FuncionesProvider } from '../../providers/funciones/funciones';

import { CalendarioPage } from '../../pages/calendario/calendario';
import { LoginPage } from '../../pages/login/login';
import { VerimagenPage } from '../../pages/verimagen/verimagen';
import { CalendarModal, CalendarModalOptions, DayConfig, CalendarResult } from "ion2-calendar";
import { CalendarComponentOptions } from 'ion2-calendar'
import { FormBuilder, FormGroup, Validators} from '@angular/forms';


import { AlbtrabajadoresPage } from '../../pages/albtrabajadores/albtrabajadores';

import * as XLSX from '../../xlsx';

import { File } from '@ionic-native/file';

@IonicPage()

@Component({
  selector: 'page-albaranes',
  templateUrl: 'albaranes.html',
})
export class AlbaranesPage {

  diasdefiesta;
  myForm: FormGroup;
  myForm1: FormGroup;
  misapp: Array<{title: string, descripcion: string, imagen: string , component: any}>;
  formulario = {tipo1: ""}
  resultado;
  date: string;
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  minuto = []; //= {valor: "1",color: "1"}
  minH = []; //= {valor: "1",color: "1"}
  color = []; //= {valor: "1",color: "1"}
  cabecera = []; //= {valor: "1",color: "1"}
  picajes;
  valo="654321123456" ;
  formulario2 = {valor: ""}
  FROM = "";
  rs_picajes;
  FechaIni;
  FechaFin;
  rs_xls;
  rs_dias;
  muestragif = "";
  imagenobtenida;
  imagenes;
  imaahora;
  myParam = '';
   optionsRange: CalendarModalOptions = {
   	pickMode:"single",
    color:'dark',
    weekStart:0,
    weekdays:['LU', 'MA', 'MI', 'JU', 'VI', 'SA', 'DO'],
    monthFormat: 'MMM',
    canBackwardsSelected: true,
    defaultDate: this.variables.DIA,
	daysConfig: this.variables._daysConfig
  };
  constructor(

   private alertCtrl: AlertController,
	private platform: Platform,
	public fb: FormBuilder,
	public modalCtrl: ModalController,
	public navCtrl: NavController,
	public funciones:FuncionesProvider,
	public variables:VariablesProvider,
	public file: File

	) {                    
	

	  this.variables.btatras = true;
	
	  var f = new Date();
	  this.FROM =  f.getFullYear() + "-" + ("0" + (f.getMonth() + 1)).slice(-2) + "-" +("0" + (f.getDate())).slice(-2) ;
	  this.FechaIni = this.FROM ;
	  this.FechaFin = this.FROM ;

	  //console.log("Valor de variable dia:" + this.variables.DIA);

	  this.date = this.variables.DIA;

	  var administrador =  this.variables.CLIENTES_RAZSOCIAL ;

	  var f = new Date();
	  this.FROM =  this.variables.DIA;
 
	  this.myForm = this.fb.group({	 
	  tipo: ['']	
	 });

	 this.myForm1 = this.fb.group({

	  codigo1: ['', [Validators.required]],
	  nombre1: ['', [Validators.required]],
	  horas1: ['', [Validators.required]],
	  horainicio1: ['', [Validators.required]],
	  activo1: ['', [Validators.required]]
	
	 });
   
   
    
    this.muestragif = "si";
	



	this.obtenerpicajes();
	    
	//this.poneimagenes();

 if (this.variables.primeravez=="si"){                   

  	  	this.pintargrafica();

        this.variables.primeravez="no";

	   
    }
  


  }


  openModalWithParams(idlinea) {
    let myModal = this.modalCtrl.create(VerimagenPage, {
     'caption': this.myParam ,
     'tabla': "ALBARANES" ,
     'campo': "imagen" ,
     'idgrupo': idlinea
     });
    myModal.present();
  }


pintargrafica(){



	this.funciones.obtienealbaranesdias(this.variables.CODIGOTRABAJADOR).then(
		  data => {

		 this.rs_dias = data
		 this.muestragif = "no";
	  	 this.variables._daysConfig = [];


	  	 //console.log("Pone a cero trabajador y dias1");

		 for (var _i = 0; _i < this.rs_dias.length; _i++) {

			   this.variables._daysConfig.push({
                date: new Date(this.rs_dias[_i].DIA),
                subTitle: this.rs_dias[_i].NUMERO,
                cssClass: 'diaOcupado'


            })


			}

		this.navCtrl.setRoot(this.navCtrl.getActive().component);


	
 
		  }
	  )
	  .catch(
		error => {
		  console.log(error);
		}
	  )
  }




  borrar(id){

			   this.funciones.delpicada(id).then(
				   data => {
				   this.muestragif = "si";
				   this.obtenerpicajes();

				  })           

	 
  }


 vertodo() {

   this.variables.imprimir = true;
	

  }



  onChange($event) {

	var cadena  = $event;
	
	this.variables.DIA = $event;
	this.muestragif = "si";
   this.obtenerpicajes();
  
  }

buscartrabajadores(){
	 var neutro;
	this.muestragif = "si";
	if (this.formulario2.valor != ""){
	  neutro = this.formulario2.valor;
	 }else{
	  neutro = this.valo;
	}

	this.funciones.obtienetrabajadores(neutro).then(
		  data => {

		  	 //console.log("Pone a cero trabajador y dias2");

		  this.picajes = data;
		  this.muestragif = "no";

		  }
	  )
	  .catch(
		error => {
		  console.log(error);
		}
	  )
  }

  poneimagenes(){


		 for (var _i = 0; _i < this.rs_picajes.length; _i++) {

			

		}
  }


  obtenerpicajes(){

	var lug;
	var Local;
	this.rs_xls = [];
	this.muestragif = "si";
	this.variables._daysConfig = [];

 	if (this.variables.primeravez!="si"){  

	this.funciones.obtienealbaranesdesc(this.variables.CODIGOTRABAJADOR,this.variables.DIA,this.variables.DIA).then(
		  data => {


		 this.rs_picajes = data

		 this.muestragif = "no";


		  var horainicio=0;
		  var minutoinicio=0;
		  var minutosdelahora=0;
		  var inicioreal = 0;
		  var d = new Date();


	  	 //console.log("Pone a cero trabajador y dias3");

		this.imagenes = [];


		 for (var _i = 0; _i < this.rs_picajes.length; _i++) {
			 horainicio=0;
			 minutoinicio=0;
			 minutosdelahora=0

			  if (this.rs_picajes[_i].VERIFICADO){
			  }else{
				this.rs_picajes[_i].VERIFICADO = "NO";
			  }


				

				this.rs_picajes[_i].IMAGEN = "http://www.panel-control.com/picademo/recursos/imgs/ticket.jpg";				

	

				this.rs_xls.push({
				  TRABAJADOR: "" + this.rs_picajes[_i].TRABAJADOR,
				  TIPO: "" + this.rs_picajes[_i].SEN,
				  NUMERO: "" + this.rs_picajes[_i].NUMERO,
				  FECHA: "" + this.rs_picajes[_i].FECHA,
				  IMPORTE: "" + this.rs_picajes[_i].IMPORTE,
				  OBSERVACIONES: "" + this.rs_picajes[_i].OBSERVACIONES,
				  CONFORME: "" + this.rs_picajes[_i].VERIFICADO
				});


			}

			

			/*  for (var _i = 0; _i < this.variables.diasOcupados.length; _i++) {

                this.variables._daysConfig.push({
                date: new Date(this.variables.diasOcupados[_i].DIA),
                subTitle: "",
                disable:true,
                cssClass: 'diaOcupado'


            })
            */
			


 
		  }
	  )
	  .catch(
		error => {
		  console.log(error);
		}
	  )
	}
  }



valChange(campo:string, value:string, index:number):void{
	  


	  switch (campo) {
		 case "VERIFICADO":
		   this.rs_picajes[index].VERIFICADO = value;
		   break;
	   }
	 
	} 

editaralbaranes(index,id){

 let alert = this.alertCtrl.create({
      title: 'Grabar',
      message: '¿Confirma grabar los registros?',
      cssClass: 'alertCustomCss',
      buttons: [{
          text: 'No',
          role: 'No',
          handler: () => { 

 

           }
        },{
          text: 'Si',
          handler: () => {

						 for (var _i = 0; _i < this.rs_picajes.length; _i++) {

								this.funciones.editaalbaran(this.rs_picajes[_i].ID, this.rs_picajes[_i].VERIFICADO).then(
						      )
						      .catch(
						        error => {
						          console.log(error);
						        }
						      )
						     
							  
						  }

						 	this.obtenerpicajes();
          }
        }
      ]
    });
    
    alert.present();
		

  }


salir(){
   this.navCtrl.push(AlbtrabajadoresPage);
}


  read(bstr: string) {

  };

  write(): XLSX.WorkBook {

  
	const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.rs_xls);

	/* generate workbook and add the worksheet */
	const wb: XLSX.WorkBook = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(wb, ws, 'Hoja1');

	return wb;
  };

  /* File Input element for browser 
  onFileChange(evt: any) {
	const target: DataTransfer = <DataTransfer>(evt.target);
	if (target.files.length !== 1) throw new Error('Cannot use multiple files');
	const reader: FileReader = new FileReader();
	reader.onload = (e: any) => {
	  const bstr: string = e.target.result;
	  this.read(bstr);
	};
	reader.readAsBinaryString(target.files[0]);
  };
  */

  /* Import button for mobile */
  async import() {
   /* try {
	  const target: string = this.file.documentsDirectory || this.file.externalDataDirectory || this.file.dataDirectory || '';
	  const dentry = await this.file.resolveDirectoryUrl(target);
	  const url: string = dentry.nativeURL || '';
	  alert(`Attempting to read informepicajes.xlsx from ${url}`)
	  const bstr: string = await this.file.readAsBinaryString(url, "relaciontickets.xlsx");
	  this.read(bstr);
	} catch(e) {
	  const m: string = e.message;
	}
	*/
  };

  /* Export button */
  async export() {

	const wb: XLSX.WorkBook = this.write();
	const filename: string = "relacionalbaranes.xlsx";
	try {
	  /* generate Blob */
	  const wbout: ArrayBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
	  const blob: Blob = new Blob([wbout], {type: 'application/octet-stream'});

	  /* find appropriate path for mobile */
	  const target: string = this.file.documentsDirectory || this.file.externalDataDirectory || this.file.dataDirectory || '';
	  const dentry = await this.file.resolveDirectoryUrl(target);
	  const url: string = dentry.nativeURL || '';

	  /* attempt to save blob to file */
	  await this.file.writeFile(url, filename, blob, {replace: true});

	} catch(e) {
	  XLSX.writeFile(wb, filename);
	}
  };


}



// WEBPACK FOOTER //
// ./src/pages/albaranes/albaranes.ts